import React, {createRef, useEffect} from 'react';
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import Footer from "../../core/layout/footer/footer";
import "./contactUs.css";

const ContactUsView = (props) => {
    const scrollTo = {
        name:        createRef(),
        email:       createRef(),
        phoneNumber: createRef(),
        website:     createRef(),
        description: createRef()
    };

    const {
        isMobileView, handleChange, name, nameError, email, emailError,
        website, websiteError, description, descriptionError,
        phoneNumber, phoneNumberError, handleSubmit, onBlurInputText
    } = props;

    useEffect(() => {
        if (scrollTo[props.scrollToElement]?.current) {
            const topOffset = isMobileView ? 50 : 90;
            const element = scrollTo[props.scrollToElement].current;
            if (element && Math.abs(element.getBoundingClientRect().top) >= topOffset + 3) {
                window.focus();
                window.scrollTo({
                    top: element.getBoundingClientRect().top + window.scrollY - topOffset,
                    behavior: 'smooth',
                });
            }
        }
    }, [props.scrollToElement]);

    return (
        <div className="w-100 cu-page">
            <section className="cu-section">
                <div className="cu-wrap">
                    <div className="cu-layout">

                        {/* ── LEFT: Form ───────────────────────────── */}
                        <div className="cu-form-side">
                            <div className="cu-section-tag">Get In Touch</div>
                            <h1 className="cu-heading">
                                Let's talk about<br />what you're <span>building.</span>
                            </h1>
                            <p className="cu-sub">
                                Fill in the form and we'll get back to you within one business day.
                            </p>

                            {/* Row 1: Name + Phone */}
                            <div className="cu-row-2">
                                <div className="cu-field" ref={scrollTo['name']}>
                                    <label className={`cu-label${nameError ? ' cu-label-err' : ''}`}>
                                        First Name<span className="cu-req">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`cu-input${nameError ? ' cu-input-err' : ''}`}
                                        placeholder=""
                                        value={name}
                                        onChange={e => handleChange('name', e.target.value)}
                                        onBlur={() => onBlurInputText('name')}
                                        maxLength={51}
                                    />
                                    {nameError && <span className="cu-err-msg">{nameError}</span>}
                                </div>
                                <div className="cu-field" ref={scrollTo['phoneNumber']}>
                                    <label className={`cu-label${phoneNumberError ? ' cu-label-err' : ''}`}>
                                        Phone Number<span className="cu-req">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`cu-input${phoneNumberError ? ' cu-input-err' : ''}`}
                                        placeholder=""
                                        value={phoneNumber}
                                        onChange={e => handleChange('phoneNumber', e.target.value)}
                                        onBlur={() => onBlurInputText('phoneNumber')}
                                        maxLength={51}
                                    />
                                    {phoneNumberError && <span className="cu-err-msg">{phoneNumberError}</span>}
                                </div>
                            </div>

                            {/* Row 2: Email + Website */}
                            <div className="cu-row-2">
                                <div className="cu-field" ref={scrollTo['email']}>
                                    <label className={`cu-label${emailError ? ' cu-label-err' : ''}`}>
                                        Work Email<span className="cu-req">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`cu-input${emailError ? ' cu-input-err' : ''}`}
                                        placeholder=""
                                        value={email}
                                        onChange={e => handleChange('email', e.target.value)}
                                        onBlur={() => onBlurInputText('email')}
                                        maxLength={51}
                                    />
                                    {emailError && <span className="cu-err-msg">{emailError}</span>}
                                </div>
                                <div className="cu-field" ref={scrollTo['website']}>
                                    <label className={`cu-label${websiteError ? ' cu-label-err' : ''}`}>
                                        Company Website
                                    </label>
                                    <input
                                        type="text"
                                        className={`cu-input${websiteError ? ' cu-input-err' : ''}`}
                                        placeholder=""
                                        value={website}
                                        onChange={e => handleChange('website', e.target.value)}
                                        onBlur={() => onBlurInputText('website')}
                                        maxLength={51}
                                    />
                                    {websiteError && <span className="cu-err-msg">{websiteError}</span>}
                                </div>
                            </div>

                            {/* Row 3: Message */}
                            <div className="cu-field" ref={scrollTo['description']}>
                                <label className={`cu-label${descriptionError ? ' cu-label-err' : ''}`}>
                                    Message<span className="cu-req">*</span>
                                </label>
                                <textarea
                                    className={`cu-textarea${descriptionError ? ' cu-input-err' : ''}`}
                                    rows={5}
                                    placeholder=""
                                    value={description}
                                    onChange={e => handleChange('description', e.target.value)}
                                    onBlur={() => onBlurInputText('description')}
                                    maxLength={501}
                                />
                                {descriptionError && <span className="cu-err-msg">{descriptionError}</span>}
                            </div>

                            <button className="cu-submit-btn" onClick={handleSubmit}>
                                Send Message
                            </button>
                        </div>

                        {/* ── RIGHT: Contact details ────────────────── */}
                        <div className="cu-info-side">
                            <h2 className="cu-info-heading">Contact details</h2>

                            <div className="cu-contact-item">
                                <div className="cu-contact-icon">
                                    <i className="fas fa-envelope"></i>
                                </div>
                                <div>
                                    <div className="cu-contact-label">EMAIL</div>
                                    <a href="mailto:hello@deccanlogic.com" className="cu-contact-value">
                                        info@deccanlogic.com
                                    </a>
                                </div>
                            </div>

                            <div className="cu-contact-item">
                                <div className="cu-contact-icon">
                                    <i className="fas fa-phone-alt"></i>
                                </div>
                                <div>
                                    <div className="cu-contact-label">PHONE</div>
                                    <a href="tel:+919322213960" className="cu-contact-value">
                                        +91 9322213960
                                    </a>
                                </div>
                            </div>

                            <div className="cu-contact-item">
                                <div className="cu-contact-icon">
                                    <i className="fas fa-map-marker-alt"></i>
                                </div>
                                <div>
                                    <div className="cu-contact-label">LOCATION</div>
                                    <div className="cu-contact-value">
                                        Pune, Maharashtra, India
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ── Map ─────────────────────────────────── */}
            <section className="cu-map-section">
                <div className="cu-wrap">
                    <iframe
                        title="DeccanLogic Office"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.2768035138283!2d73.94211117612926!3d18.561555367919283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3dcc4f0e6f7%3A0xa7058ccb94fa7be0!2sDeccanlogic%20Private%20Limited!5e0!3m2!1sen!2sin!4v1694422290844!5m2!1sen!2sin"
                        width="100%"
                        height="420"
                        style={{border: 0, display: 'block', borderRadius: '18px'}}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </section>

            <Footer {...props}/>
        </div>
    );
};

ContactUsView.propTypes = {};

const mapStateToProps = state => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isXSView:     state.appState.deviceInfo.isXSView,
    isSMView:     state.appState.deviceInfo.isSMView,
    isMDView:     state.appState.deviceInfo.isMDView,
});

export default connect(mapStateToProps, {})(withTranslation('translations')(ContactUsView));
